/// <amd-module name="Artifacts/Connect/types/IProtocol" />

import { PackagingService } from "Artifacts/Connect/services/PackagingService";
import { ICombinedFeedView } from "Artifacts/Connect/types/ICombinedFeedView";

export interface IProtocol {
  /**
   * Protocol human-friendly name.
   */
  readonly name: string;

  /**
   * Protocol area helps contruct path to package registry index.
   */
  readonly area: string;

  /**
   * Protocol feature flag.
   */
  readonly featureFlag?: string;

  /**
   *
   * @param packagingService
   * @param combinedFeedView
   */
  getFeedUrl(packagingService: PackagingService, combinedFeedView: ICombinedFeedView): string;
}
